import { dxpRoutes } from './app/dxp-routes';
import {
  dxpErrorComponentConfig,
  provideDxpInitializers,
} from './app/initializers';
import { DxpLuigiAuthEventsCallbacksService } from './app/service/dxp-luigi-auth-events-callbacks.service';
import { DxpAppSwitcherConfigService } from './app/service/luigiConfig/app-switcher-config.service';
import { DxpCustomGlobalNodesService } from './app/service/luigiConfig/custom-global-nodes.service';
import { FrameEntityChangedListener } from './app/service/luigiConfig/custom-message-listeners/frame-entity-changed-listener.service';
import { GithubToolsInstallationRequestListener } from './app/service/luigiConfig/custom-message-listeners/github-custom-message-listeners/github-tools-installation-request-listener.service';
import { GithubToolsTokenRequestListener } from './app/service/luigiConfig/custom-message-listeners/github-custom-message-listeners/github-tools-token-request-listener.service';
import { GithubWdfInstallationRequestListener } from './app/service/luigiConfig/custom-message-listeners/github-custom-message-listeners/github-wdf-installation-request-listener.service';
import { GithubWdfTokenRequestListener } from './app/service/luigiConfig/custom-message-listeners/github-custom-message-listeners/github-wdf-token-request-listener.service';
import { ProjectCreatedListener } from './app/service/luigiConfig/custom-message-listeners/project-created-listener';
import { ReloadFrameListener } from './app/service/luigiConfig/custom-message-listeners/reload-frame-listener.service';
import { DxpCustomNodeProcessingService } from './app/service/luigiConfig/custom-node-processing.service';
import { DxpGlobalSearchConfigService } from './app/service/luigiConfig/global-search-config.service';
import { DxpHeaderBarConfigService } from './app/service/luigiConfig/luigi-breadcrumb.service';
import { DxpLuigiExtendedGlobalContextConfigService } from './app/service/luigiConfig/luigi-node-extended-context.service';
import { DxpNodeChangeHookConfigService } from './app/service/luigiConfig/node-change-hook.service';
import { DxpRoutingConfigServiceImpl } from './app/service/luigiConfig/router-config.service';
import { DxpStaticSettingsConfigService } from './app/service/luigiConfig/static-settings-config.service';
import { DxpUserProfileConfigService } from './app/service/luigiConfig/user-profile-config.service';
import { DxpLocalConfigurationService } from './app/service/luigiNodes/dxp-local-configuration.service';
import { LuigiThemingService } from './app/service/luigiNodes/luigi-theming.service';
import { TrustChangedListenerService } from './app/trust-changed-listener.service';
import { TrustDataUpdateListener } from './app/trust-data-update-listener.service';
import { ErrorHandler, isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import {
  MessageToastService,
  provideMessageToastConfig,
} from '@fundamental-ngx/core';
import {
  LuigiContextService,
  LuigiContextServiceImpl,
} from '@luigi-project/client-support-angular';
import {
  PortalComponent,
  PortalOptions,
  providePortal,
} from '@openmfp/portal-ui-lib';
import {
  browserTracingIntegration,
  createErrorHandler,
  init,
} from '@sentry/angular';
import '@ui5/webcomponents-icons/dist/AllIcons.js';
import { provideNamedApollo } from 'apollo-angular';

const portalOptions: PortalOptions = {
  customMessageListeners: [
    ProjectCreatedListener,
    FrameEntityChangedListener,
    TrustChangedListenerService,
    TrustDataUpdateListener,
    GithubToolsTokenRequestListener,
    GithubWdfTokenRequestListener,
    GithubToolsInstallationRequestListener,
    GithubWdfInstallationRequestListener,
    ReloadFrameListener,
  ],
  staticSettingsConfigService: DxpStaticSettingsConfigService,
  localConfigurationService: DxpLocalConfigurationService,
  globalSearchConfigService: DxpGlobalSearchConfigService,
  appSwitcherConfigService: DxpAppSwitcherConfigService,
  userProfileConfigService: DxpUserProfileConfigService,
  nodeChangeHookConfigService: DxpNodeChangeHookConfigService,
  luigiExtendedGlobalContextConfigService:
    DxpLuigiExtendedGlobalContextConfigService,
  customGlobalNodesService: DxpCustomGlobalNodesService,
  customNodeProcessingService: DxpCustomNodeProcessingService,
  luigiAuthEventsCallbacksService: DxpLuigiAuthEventsCallbacksService,
  themingService: LuigiThemingService,
  errorComponentConfig: dxpErrorComponentConfig,
  headerBarConfigService: DxpHeaderBarConfigService,
  routingConfigService: DxpRoutingConfigServiceImpl,
};

function getEnv(): string {
  switch (location.hostname.split('.')[1]) {
    case 'd1':
      return 'dev';
    case 'i1':
      return 'int';
    default:
      return 'live';
  }
}

if (!isDevMode()) {
  init({
    dsn: 'https://6e3d78f3439d7ed13bd71ead7d206eb2@o1240783.ingest.us.sentry.io/4508931443064842',
    integrations: [browserTracingIntegration()],
    tracesSampleRate: 1,
    environment: getEnv(),
  });
}

bootstrapApplication(PortalComponent, {
  providers: [
    provideRouter(dxpRoutes),
    provideNamedApollo(() => ({})),
    provideDxpInitializers(),
    provideMessageToastConfig({}),
    MessageToastService,
    providePortal(portalOptions),
    {
      provide: ErrorHandler,
      useValue: createErrorHandler({
        showDialog: false,
        logErrors: true,
      }),
    },
    {
      provide: LuigiContextService,
      useClass: LuigiContextServiceImpl,
    },
  ],
}).catch((err) => {
  console.error(err);
});
